import { useState } from 'react'
import PropTypes from 'prop-types'
import { FlipHorizontal, FlipVertical } from 'lucide-react'
import { useTools } from "../../ToolProvider.jsx";
import SideMenu from './SideMenu.jsx';

// El eje sobre el que se espeja. `each` deja cada objeto donde está y solo le
// da la vuelta; los demás usan la misma caja objetivo que "alinear respecto a",
// así que con varios objetos también intercambian posiciones dentro de ella.
const REFERENCE_OPTIONS = [
    { value: 'selection', label: 'Selección' },
    { value: 'each', label: 'Cada objeto' },
    { value: 'first', label: 'Primero seleccionado' },
    { value: 'biggest', label: 'El más grande' },
    { value: 'background', label: 'Fondo' },
];

const DropdownMirror = ({ selectedCount = 0 }) => {
    const { onMirrorObjects } = useTools();
    const [referenceMode, setReferenceMode] = useState('selection');

    if (selectedCount < 1) return null;

    return (
        <SideMenu
            tip="Espejar selección"
            icon={<FlipHorizontal className="w-10 h-10" />}
            menuClassName="menu p-2 w-56 gap-2"
        >
                <select
                    className="select select-sm select-bordered w-full"
                    value={referenceMode}
                    onChange={(event) => setReferenceMode(event.target.value)}
                >
                    {REFERENCE_OPTIONS.map(({ value, label }) => (
                        <option key={value} value={value}>Respecto a: {label}</option>
                    ))}
                </select>

                <div className="grid grid-cols-2 gap-1">
                    <button
                        type="button"
                        className="btnMod tooltip tooltip-bottom"
                        data-tip="Espejar horizontalmente"
                        onClick={() => onMirrorObjects('horizontal', referenceMode)}
                    >
                        <FlipHorizontal className="w-6 h-6" />
                    </button>
                    <button
                        type="button"
                        className="btnMod tooltip tooltip-bottom"
                        data-tip="Espejar verticalmente"
                        onClick={() => onMirrorObjects('vertical', referenceMode)}
                    >
                        <FlipVertical className="w-6 h-6" />
                    </button>
                </div>
        </SideMenu>
    );
};

DropdownMirror.propTypes = {
    selectedCount: PropTypes.number,
};

export default DropdownMirror;
